import React, {ReactNode} from "react";
import {useRegisterLayout} from "./LayoutShell";


interface CommonLayoutProps {
    children: ReactNode;
    showFooter?: boolean;
    showSideNav?: boolean;
    showTopNavUserControls?: boolean;
}

/**
 * Declares that this page uses the app chrome. The chrome (top nav, side nav,
 * footer) is rendered once by LayoutShell above the router, so navigating
 * between pages no longer remounts the side nav — only this page's content
 * changes.
 */
const MainLayout: React.FC<CommonLayoutProps> = ({children, showFooter = true, showSideNav = true, showTopNavUserControls = true}) => {

    useRegisterLayout({showFooter, showSideNav, showTopNavUserControls});

    return <>{children}</>;
};

export default MainLayout;
